export default {
  hero: {
    title: 'リソースセンター',
    subtitle: 'アジア太平洋地域における IT サービス提供に役立つ、コンプライアンス解説、運用ガイド、引継ぎテンプレート、イベント情報をまとめています。',
    imageAlt: 'リソースセンター背景画像',
    searchPlaceholder: 'インサイト、資料、イベントを検索...'
  },
  tabs: {
    all: 'すべて',
    insights: '業界インサイト',
    downloads: '資料ダウンロード',
    knowledge: 'ナレッジベース',
    events: 'イベント情報'
  },
  insights: {
    title: '業界インサイト',
    subtitle: 'データ保護、マネージドサービス提供、クラウドレジリエンスを中心に、Web、サポート、CRM、運用現場に役立つ内容を整理しています。',
    viewAll: 'すべてのインサイトを見る',
    readMore: '続きを読む',
    items: [
      {
        id: 1,
        title: '2026年 シンガポール PDPA 実務ポイント：ガバナンスと ICT 統制',
        description: 'PDPC 公開資料をもとに、DPO 体制、Web フォーム、委託先管理、データ漏えい通知対応の要点を整理しました。',
        image: '/images/resourceCenter/insight-report.jpg',
        badge: 'コンプライアンス',
        badgeColor: 'bg-blue-600',
        date: '2026年4月10日',
        readTime: '8分',
        author: 'Mingyu Zhang',
        authorAvatar: '/images/resourceCenter/author-zhang.png'
      },
      {
        id: 2,
        title: '韓国 PIPA 2026 実務観点：越境処理と委託管理',
        description: '韓国での Web、サポート、地域間連携に関わる越境取扱い、委託処理、証跡管理の論点をまとめています。',
        image: '/images/resourceCenter/insight-singapore-pdpa.jpg',
        badge: '政策解説',
        badgeColor: 'bg-green-600',
        date: '2026年4月9日',
        readTime: '7分',
        author: 'Meiling Lin',
        authorAvatar: '/images/resourceCenter/author-lin.png'
      },
      {
        id: 3,
        title: 'クラウドレジリエンス基準：マルチリージョン DR と復旧順序',
        description: 'Web、サポート、通知、CRM を含むサービスの復旧優先度、Runbook 設計、切替演習の考え方を整理しました。',
        image: '/images/resourceCenter/insight-korea-pipa.jpg',
        badge: 'アーキテクチャ',
        badgeColor: 'bg-red-600',
        date: '2026年4月12日',
        readTime: '9分',
        author: 'Minsu Kim',
        authorAvatar: '/images/resourceCenter/author-kim.png'
      }
    ]
  },
  downloads: {
    title: '資料ダウンロード',
    subtitle: '社内共有や顧客報告にも使いやすい、詳細化した PDF チェックリストとテンプレートを提供します。',
    viewAll: 'すべての資料を見る',
    action: 'ダウンロード',
    items: [
      {
        id: 1,
        title: 'APAC データ保護準備度チェックリスト',
        description: 'Web、サポート、CRM、マーケティング自動化、外部 SaaS を対象とした実務向けチェック項目です。',
        badge: 'チェックリスト',
        badgeClass: 'text-blue-600 bg-blue-50',
        iconBg: 'bg-blue-100 text-blue-600',
        iconClass: 'fas fa-list-check text-blue-600',
        date: '2026年4月更新',
        fileInfo: 'PDF チェックリスト'
      },
      {
        id: 2,
        title: 'マルチリージョン DR Runbook テンプレート',
        description: '復旧優先度、コミュニケーション、承認経路、演習レビューを含む Runbook テンプレートです。',
        badge: 'テンプレート',
        badgeClass: 'text-green-600 bg-green-50',
        iconBg: 'bg-green-100 text-green-600',
        iconClass: 'fas fa-file-lines text-green-600',
        date: '2026年4月更新',
        fileInfo: 'PDF Runbook テンプレート'
      },
      {
        id: 3,
        title: 'マネージドサービス引継ぎ・Go-Live チェックリスト',
        description: '新規案件、ベンダー切替、運用引継ぎ、リリース前確認に使える資料です。',
        badge: 'デリバリー',
        badgeClass: 'text-purple-600 bg-purple-50',
        iconBg: 'bg-purple-100 text-purple-600',
        iconClass: 'fas fa-clipboard-check text-purple-600',
        date: '2026年4月更新',
        fileInfo: 'PDF 引継ぎチェックリスト'
      }
    ]
  },
  knowledge: {
    title: 'ナレッジベース',
    subtitle: 'プラットフォーム運用、障害切り分け、監査対応、マネージドサービス実行に役立つ実務向け資料です。',
    viewAll: 'すべての文書を見る',
    readDoc: '文書を読む',
    categories: {
      all: 'すべて',
      operation: '運用',
      troubleshooting: '障害対応',
      compliance: 'コンプライアンス',
      security: 'セキュリティ'
    },
    hotTitle: '注目の技術文書',
    hotSubtitle: '本番運用、復旧、監査準備に役立つ実践資料。',
    operationTitle: '運用',
    troubleshootingTitle: '障害対応',
    hotDocuments: [
      {
        id: 1,
        title: 'Kubernetes コントロールプレーンと etcd バックアップ/復旧 Runbook',
        description: 'kubeadm クラスタ、etcd スナップショット、コントロールプレーン検証、業務入口確認に焦点を当てた資料です。',
        category: '運用',
        categoryClass: 'bg-blue-50 text-blue-600',
        iconBg: 'bg-blue-100 text-blue-600',
        iconClass: 'fas fa-server text-blue-600',
        views: '1.9k 閲覧',
        date: '2026年4月',
        comments: '18 件'
      },
      {
        id: 2,
        title: '分散障害のトリアージとコミュニケーションマトリクス',
        description: '技術切り分け、業務影響判定、対外コミュニケーションを揃えるための実務ガイドです。',
        category: '障害対応',
        categoryClass: 'bg-red-50 text-red-600',
        iconBg: 'bg-red-100 text-red-600',
        iconClass: 'fas fa-bug text-red-600',
        views: '1.6k 閲覧',
        date: '2026年4月',
        comments: '12 件'
      },
      {
        id: 3,
        title: 'マネージドサービス向けセキュリティ確認チェックリスト',
        description: '権限、ログ、変更管理、第三者アクセス管理を対象とした簡潔な確認リストです。',
        category: 'コンプライアンス',
        categoryClass: 'bg-green-50 text-green-600',
        iconBg: 'bg-green-100 text-green-600',
        iconClass: 'fas fa-shield-alt text-green-600',
        views: '1.3k 閲覧',
        date: '2026年4月',
        comments: '9 件'
      }
    ],
    operationTips: [
      'コントロールプレーン変更前に、バックアップ、証明書、復旧依存関係を確認する',
      'デプロイ、ロールバック、変更記録を同じ当番手順書にまとめる',
      'DB、オブジェクトストレージ、キューごとに個別のバックアップ検証周期を定義する',
      'ログ保持は障害解析、監査、顧客説明の三用途を想定して設計する'
    ],
    troubleshootingTips: [
      '障害は顧客接点、制御面、データ面、外部依存の4層で切り分ける',
      'インシデントオーナー、業務側窓口、対外更新タイミングを早期に固定する',
      '復旧演習では DNS、証明書、通知、チケット連携まで確認する',
      'ポストモーテムではボトルネック、手作業、ベンダー依存を記録して Runbook に反映する'
    ]
  },
  events: {
    title: 'イベント情報',
    subtitle: 'コンプライアンス、プラットフォーム運用、サービスレジリエンスをテーマにした、開催済みイベントの要点と資料を掲載しています。',
    viewAll: 'すべてのイベントを見る',
    featured: {
      badge: 'セッション回顧',
      title: '2026 APAC データレジリエンス・コンプライアンスラウンドテーブル回顧',
      description: 'IT リーダー、DPO、プラットフォーム担当者が共有した論点、判断基準、アクションを整理した回顧です。',
      date: '2026年3月12日',
      location: 'シンガポール / オンライン併催',
      audience: 'IT リーダー、DPO、プラットフォーム担当',
      status: '開催終了',
      metaNote: '会後メモと関連資料をアーカイブ済み',
      action: '回顧を見る'
    },
    recentTitle: '最近の回顧',
    recentSubtitle: '以下はすべて開催済みイベントの回顧、要点整理、関連資料です。',
    recentItems: [
      {
        id: 1,
        day: '26',
        month: '3月',
        dateBg: 'bg-blue-100 text-blue-700',
        badge: '回顧',
        badgeClass: 'bg-blue-50 text-blue-700',
        title: 'シンガポール PDPA と漏えい通知実務 回顧',
        icon: 'far fa-clock',
        info: 'オンライン開催・メモ公開済み',
        action: '回顧を見る',
        linkClass: 'text-blue-600 hover:text-blue-700'
      },
      {
        id: 2,
        day: '05',
        month: '3月',
        dateBg: 'bg-green-100 text-green-700',
        badge: 'ワークショップ回顧',
        badgeClass: 'bg-green-50 text-green-700',
        title: 'Kubernetes コントロールプレーンと etcd バックアップ演習 回顧',
        icon: 'fas fa-map-marker-alt',
        info: '上海・実機演習メモ',
        action: '回顧を見る',
        linkClass: 'text-green-600 hover:text-green-700'
      },
      {
        id: 3,
        day: '20',
        month: '2月',
        dateBg: 'bg-purple-100 text-purple-700',
        badge: 'ラウンドテーブル回顧',
        badgeClass: 'bg-purple-50 text-purple-700',
        title: 'リージョン DR 演習設計ラウンドテーブル 回顧',
        icon: 'far fa-clock',
        info: 'オンライン討議・要点整理',
        action: '回顧を見る',
        linkClass: 'text-purple-600 hover:text-purple-700'
      },
      {
        id: 4,
        day: '16',
        month: '1月',
        dateBg: 'bg-red-100 text-red-700',
        badge: 'ブリーフィング回顧',
        badgeClass: 'bg-red-50 text-red-700',
        title: 'マネージドサービス引継ぎと SLA コミュニケーション説明会 回顧',
        icon: 'fas fa-map-marker-alt',
        info: 'オンライン開催・資料保管済み',
        action: '回顧を見る',
        linkClass: 'text-red-600 hover:text-red-700'
      }
    ]
  },
  contactCta: {
    badge: 'お問い合わせ',
    title: '実際の業務シナリオに合った資料や提案が必要ですか？',
    subtitle: 'Web サイト構築、地域運用、マネージドサービス、DR 演習、顧客サポート改善をご検討中であれば、直接お問い合わせください。状況に合わせて、参考資料、導入の優先事項、地域対応の進め方を整理してご案内します。',
    highlights: [
      'Web とサポートの相談',
      '地域運用とデリバリー連携',
      '資料取得と提案相談'
    ],
    note: '中国本土、シンガポール、日本、韓国などの地域案件を想定したご相談に対応します。',
    action: 'お問い合わせページへ'
  }
}
